import { IHooksUseRequestIgnoreReportParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestIgnoreReportParams;
type TResponseData = void;

export const useRequestIgnoreReport = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.reports.base, 'ignore'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.reports.ignore, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'reportIgnored', data })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.reports.base)
        ])
    )
  });

  const triggerIgnoreReport = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingIgnoreReport: isPending,
    triggerIgnoreReport,
    error
  });

};  
